module.exports = "<p>\r\n  approvequote works!\r\n</p>\r\n"